import { People, CheckCircle, Cancel } from '@mui/icons-material';
import { Button, Card, CardContent, Typography, Box } from '@mui/material';

export function BulkActions({ students, markAllPresent, markAllAbsent }) {
  return (
    <Card className='  rounded-lg border  shadow-md w-full '>
      <CardContent className='md:p-6'>
        <Box className='flex items-center gap-2 mb-2'>
          <People className='' />
          <Typography variant='h6' className='font-medium'>
            Bulk Actions
          </Typography>
        </Box>

        <Typography variant='body1' className=' mb-2'>
          Mark attendance for all {students.length} students at once
        </Typography>

        <Box className='space-y-3 flex flex-col'>
          <Button
            onClick={markAllPresent}
            variant='outlined'
            fullWidth
            startIcon={<CheckCircle />}
            className='gap-2 border-green-200 text-green-700 hover:bg-green-50 font-medium w-fit'
            sx={{
              borderColor: '#fecaca',
              color: '#b91c1c',
              '&:hover': {
                backgroundColor: '#fef2f2',
                borderColor: '#fecaca',
              },
            }}
          >
            Mark All ({students.length}) {''}Present
          </Button>

          <Button
            onClick={markAllAbsent}
            variant='outlined'
            fullWidth
            startIcon={<Cancel />}
            className='gap-2 border-red-200 text-red-700 hover:bg-red-50 font-medium w-fit'
            sx={{
              borderColor: '#fecaca',
              color: '#b91c1c',
              '&:hover': {
                backgroundColor: '#fef2f2',
                borderColor: '#fecaca',
              },
            }}
          >
            Mark All ({students.length}) Absent &nbsp;&nbsp;
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
